export default "/assets/images/mila-valentine-mobile.f58757ce0870bb76.webp";